// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { TableCellLayout } from '@fluentui/react-components';
import { CourseType } from '@microsoft/vscodeedu-api';
import React from 'react';
import { CourseTypeText } from '../common';

// Curriculum type cell properties.
export type TypeCellProps = Readonly<{
    value: CourseType;
}>;

// Curriculum type data grid cell contents.
export default (props: TypeCellProps) => {
    const { value } = props;
    return (
        <TableCellLayout>
            <CourseTypeText value={value} />
        </TableCellLayout>
    );
};
